module.exports = __webpack_public_path__ + "img/partner37.16ff6ff6.png";